import { render, staticRenderFns } from "./DesktopCustomerSlotCalendar.vue?vue&type=template&id=d2b18e32&"
import script from "./DesktopCustomerSlotCalendar.vue?vue&type=script&lang=js&"
export * from "./DesktopCustomerSlotCalendar.vue?vue&type=script&lang=js&"
import style0 from "./DesktopCustomerSlotCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports